import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { PageHeader, SectionHeading } from "../components/ui";

const values = [
  { title: "Innovation", body: "We push the boundaries of chip design to create groundbreaking solutions that shape the future." },
  { title: "Collaboration", body: "Our strength lies in our partnerships, working closely with clients to bring complex ideas to life." },
  { title: "Quality", body: "We are committed to the highest standards of quality, ensuring reliable and robust performance." },
];

const DESCRIPTION =
  "Chiparama's mission and values: delivering cutting-edge chip design and verification services that help clients lead in AI, 5G and automotive.";

export default function AboutPage() {
  return (
    <>
      <Helmet>
        <title>Mission & Values | Chiparama</title>
        <meta name="description" content={DESCRIPTION} />
        <link rel="canonical" href="https://chiparama.com/about" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Mission & Values | Chiparama" />
        <meta property="og:description" content={DESCRIPTION} />
        <meta property="og:url" content="https://chiparama.com/about" />
        <meta property="og:image" content="https://chiparama.com/chiparamalogo.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mission & Values | Chiparama" />
        <meta name="twitter:description" content={DESCRIPTION} />
        <meta name="twitter:image" content="https://chiparama.com/chiparamalogo.jpg" />
      </Helmet>

      <PageHeader eyebrow="Mission & values" title="Innovating the future of semiconductors.">
        We are pioneers at the forefront of semiconductor innovation. Our mission is to engineer the
        core technology that powers tomorrow's world.
      </PageHeader>

      <section className="section bg-white">
        <div className="container-x">
          <SectionHeading eyebrow="Values" title="What we hold ourselves to." />
          <div className="grid gap-5 md:grid-cols-3">
            {values.map((v, i) => (
              <div key={v.title} className="card">
                <span className="font-mono text-xs text-brand">0{i + 1}</span>
                <h3 className="mt-4 text-xl font-semibold text-ink">{v.title}</h3>
                <p className="mt-3 leading-relaxed text-slate-600">{v.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="on-dark section bg-navy-900 text-white">
        <div className="container-x grid gap-12 md:grid-cols-2">
          <div>
            <p className="eyebrow mb-4">Our mission</p>
            <p className="text-2xl font-medium leading-snug md:text-3xl">
              To be the trusted partner for next-generation technology, delivering cutting-edge chip
              design and verification services that enable our clients to lead in their respective
              industries, from AI and 5G to automotive.
            </p>
          </div>
          <div>
            <p className="eyebrow mb-4">Our vision</p>
            <p className="text-2xl font-medium leading-snug text-slate-300 md:text-3xl">
              To shape a connected, intelligent, and sustainable world by pioneering the semiconductor
              solutions that will power the innovations of tomorrow.
            </p>
          </div>
        </div>
      </section>

      <section className="section-tight bg-white">
        <div className="container-x flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
          <h2 className="text-2xl font-semibold text-ink md:text-3xl">Meet the team behind the work.</h2>
          <Link to="/company" className="btn-primary px-7 py-3.5">Company & leadership</Link>
        </div>
      </section>
    </>
  );
}
